import Seo from "@/components/feature/Seo";
import { SITE_URL } from "@/config";
import Hero from "@/pages/home/components/Hero";
import HotRank from "@/pages/home/components/HotRank";
import CollectionsShowcase from "@/pages/home/components/CollectionsShowcase";
import LiveFeed from "@/pages/home/components/LiveFeed";
import Faq from "@/pages/home/components/Faq";

const faqSchema = [
  {
    "@type": "Question",
    name: "你们的实时吃瓜内容和别家有什么区别？",
    acceptedAnswer: {
      "@type": "Answer",
      text: "我们把散落在各平台的瓜料按主题做实时吃瓜合集与盘点整理，用清晰的分类和时间线帮你省去全网来回翻的麻烦。",
    },
  },
  {
    "@type": "Question",
    name: "蹲后续是什么意思？后续会一直更新吗？",
    acceptedAnswer: {
      "@type": "Answer",
      text: "蹲后续是指持续追踪仍在发酵的话题，我们会对有大进展的大瓜建立追更线索，并可通过邮件订阅实时吃瓜周报获取更新。",
    },
  },
  {
    "@type": "Question",
    name: "文章里的热度数据是怎么来的？",
    acceptedAnswer: {
      "@type": "Answer",
      text: "热度数据基于各平台讨论量与话题阅读的大致量级整理，用于帮助判断关注度，不代表权威统计。",
    },
  },
];

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "吃瓜日报",
  url: SITE_URL,
  logo: `${SITE_URL}/vite.svg`,
  description:
    "实时吃瓜平台，聚合全网热门大瓜、实时吃瓜合集与盘点整理的娱乐内容门户。",
};

const webSiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "吃瓜日报 - 实时吃瓜合集盘点",
  url: SITE_URL,
  description:
    "实时吃瓜平台，聚合全网热门大瓜、实时吃瓜合集与盘点整理。综艺前线、演出舞台、短剧风口、饭圈文化一站式吃瓜。",
  inLanguage: "zh-CN",
};

const faqPageSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqSchema,
};

export default function HomePage() {
  return (
    <>
      <Seo
        title="实时吃瓜 - 热门大瓜合集盘点 | 吃瓜日报"
        canonicalPath="/"
        ogType="website"
        jsonLd={[webSiteSchema, orgSchema, faqPageSchema]}
      />
      <Hero />
      <HotRank />
      <CollectionsShowcase />
      <LiveFeed />
      <Faq />
    </>
  );
}